import { PropsWithClassNameWithChildren } from "@/types/ui";
import React, { HTMLAttributeAnchorTarget } from "react";
import Link, { LinkProps } from "next/link";
import { cn } from "@lib/utils";

export const ExternalLink = (
  props: LinkProps &
    PropsWithClassNameWithChildren & {
      target?: HTMLAttributeAnchorTarget | undefined;
      disabled?: boolean;
    },
) => {
  if (props.disabled) {
    return (
      <div aria-disabled={props.disabled} className={cn("text-primary underline", props.className)}>
        {props.children && props.children}
        {!props.children && <span>{props.href as string}</span>}
      </div>
    );
  }

  return (
    <Link
      target="_blank"
      rel="noopener noreferrer"
      {...props}
      className={cn("text-primary underline", props.className)}
    >
      {props.children && props.children}
      {!props.children && <span>{props.href as string}</span>}
    </Link>
  );
};
